window.facetExapnded = false;
window.collectionBannerRendered = false;
// window.rebuySaleBadgeAdded = false;
window.renderedProducts = [];
// window.isReviewsRendered = false
// window.previousUrl = '';
window.isRebuySmartCartReady = false;

function _addMeToCart(e, el) {  
	e = e || window.event;
  	e.preventDefault();
    e.stopPropagation();
    let formData = {
      'items': [
        {
          'id': el.dataset.variant_id,
          'quantity': 1
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => { 
      return resp.json();
    })
    .then((data) => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    })
}

//used for search ountry in header section
function searchCountry(popoverId) {	  
    var input, filter, i, txtValue,btn,list,span;
    input = document.getElementById("txtSearchCountry");  
    filter = input.value.toUpperCase();
    if(filter == ""){
      filter = event.target.value.toUpperCase();
    }      
     list = document.getElementById(popoverId);    
    btn = list.getElementsByTagName("button");    
     for (i = 0; i < btn.length; i++) {
        span = btn[i].getElementsByTagName("span")[0];
        txtValue = span.textContent || span.innerText;        
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            btn[i].style.display = "";            
        } else {
            btn[i].style.display = "none";
        }
    }    
    const mediaQuery = window.matchMedia('(max-width: 480px)');
    if (mediaQuery.matches) {
      //event.target.blur();
    }
  
}

document.addEventListener("DOMContentLoaded", function() { 
  // console.log('DOM Loaded....');

  //console.log('DIGIAPI-inside filter function');
  let checkbox = document.getElementById("facets-sidebar-filter.v.availability");    

  if(checkbox != null){
    let filterApplied = false;
   // console.log('value is ',checkbox.checked);
    Shopify.queryParams = {};
    if (location.search.length) {
      var params = location.search.substr(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var keyValue = params[i].split('=');
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
          if(keyValue[0] == "filter.v.availability")
            filterApplied = true;
        }
      }
    }
    //console.log('search is',Shopify.queryParams);    
    //console.log('filter is ',filterApplied);
    // console.log('isChecked = ',checkbox.checked);
    if(!checkbox.checked && !filterApplied){
     // Shopify.queryParams["filter.v.availability"] = "1";
     // location.search = new URLSearchParams(Shopify.queryParams).toString(); 
      //checkbox.checked = true;
    // let event = new Event('change');
     // checkbox.dispatchEvent(event);
      //  console.log("event is", event);
      checkbox.click();
    }          
  }else {
    // console.log('not a collection page');
  }
 
});

const callback = (mutationList, observer) => {
  var addedNodes = []; 
  var attributesChanged = [];
  // if (window.location.href !== window.previousUrl) {
  //     // console.log(`URL changed from ${window.previousUrl} to ${window.location.href}`);
  //     window.isReviewsRendered = false;
  //     window.previousUrl = window.location.href;      
  //   }  
   mutationList.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes));   
   // mutationList.forEach((record) =>{
   //   if (record.type === "attributes"){
   //     attributesChanged.push(record.attributeName);
   //     // if(record.attributeName == 'qbhandle')
   //     //    QuicjBuyButtonsRender();
   //   }
   // });
     // console.log('Added:', addedNodes);
    // console.log('attributes',attributesChanged);
  var isCardReRendered = false;
  for(const el of addedNodes){       
    if(el.className == 'quick-buy-container__heading' || el.className == 'ais-ClearRefinements' || el.className == 'ais-Hits-item'){
     // if(el.nodeName == 'LI'){
      isCardReRendered = true;
      // observer.disconnect();
      break;
    }
  }
   if(isCardReRendered){          
     QuicjBuyButtonsRender();
       // getReviews();
     if(!window.collectionBannerRendered){
        addCollectionBanner();                    
       window.collectionBannerRendered = true;
     }
     
     // if(!window.isReviewsRendered ){
     //   //reviews badge process
     //   // yotpoWidgetsContainer.initWidgets();
     //   getReviews();
     //   window.isReviewsRendered = true;
     // }
    
     // console.log(window.facetExapnded);
     if(!window.facetExapnded){
       window.facetExapnded = true;
       expandAllFacets();
     }    
   }
};

 document.addEventListener("algolia.hooks.initialize", function () {
    algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
      const { configure } = window.algoliaShopify.externals.widgets;
      configureWidget = configure({
        facetingAfterDistinct: false,
      });
      return [configureWidget];
    });
  });

// document.addEventListener('algolia.hooks.initialize', function() {
//   algoliaShopify.hooks.registerHook('beforeISTransformItems', function(transformedItems, items) {
//     console.log(` transformedItems ${JSON.stringify(transformedItems)} items ${JSON.stringify(items)}`);
//     return transformedItems;
//   });
// });

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {    
    // QuicjBuyButtonsRender();
     // console.log('instant serach main template');
     // console.log(`facets are ${JSON.stringify(data.facets)}`);   
    return html`
         <div class="ais-page">
            <div class="container">   
            <div class="gap-6 sm:gap-12">          
              <h1 class="ais-h2" style="display:none;">${algoliaShopify.translations.searchTitle}</h1>
              <div class="ais-input"  style="display:none;">
                <div class="ais-search-box-container"></div>
                <div class="ais-input-button">
                  <div class="ais-clear-input-icon"></div>
                </div>
              </div>
              <div class="ais-facets-button">Show filters</div>
              <div class="collection">
              <safe-sticky class="facets-sidebar" style="top: 74px;">
              <div class="ais-facets">
                <div style="display: none; justify-content: space-between; padding-top: 26px">
                  <div class="ais-current-refined-values-container"></div>
                  <div style="top: 68px" class="ais-clear-refinements-container"></div>
                </div>
                ${data.facets.map(facet => html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} test-working"
                    >
                      <input
                        checked
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header _${facet.title}"
                        ><span>${facet.title}</span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill="currentColor"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </label>
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `)}
              </div>
              </div>
              <div class="ais-block">
                <div class="ais-search-header">                 
                  <div class="ais-stats-container"></div>
                  <div class="ais-change-display">
                    <span class="ais-change-display-block ais-change-display-selected">
                      <i class="fa fa-th-large">
                        <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none">
                          <path fill="currentColor" d="M0 0h4v4H0zM0 7h4v4H0zM0 14h4v4H0zM7 0h4v4H7zM7 7h4v4H7zM7 14h4v4H7zM14 0h4v4h-4zM14 7h4v4h-4zM14 14h4v4h-4z"></path>
                        </svg>
                      </i></span>
                    <span class="ais-change-display-list">
                      <i class="fa fa-th-list"><svg role="presentation" width="18" viewBox="0 0 18 18" fill="none">
                        <path fill="currentColor" d="M0 0h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0z"></path>
                        </svg>
                      </i
                    ></span>
                  </div>
                  <div class="ais-sort">
                    ${data.multipleSortOrders ? html`
                          ${algoliaShopify.translations.sortBy}
                          <span class="ais-sort-orders-container"></span>
                        `: html`
                          ${algoliaShopify.translations.sortBy}
                          ${algoliaShopify.translations.relevance}
                        `}
                  </div>
                </div>
                <div class="ais-hits-container ais-results-as-block"></div>
              </div>
              </div>
              <div class="ais-pagination-container"></div>
            </div>  
            </div>          
          </div>
    `;
  });
});

/* Algolia Product rendering */
document.addEventListener('algolia.hooks.initialize', function() { 
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) { 
   
    // // if(window.renderedProducts.length ==24)
    // //   window.renderedProducts = [];
    // // else
    //   window.renderedProducts.push(hit.id);    
    // // console.log('hit added to array');
    
    //console.log(algoliaShopify.helpers.displayPrice(hit, hit._distinct));        
    var salePrice = getFinalPrice(hit.price);
    var regularPrice = getFinalPrice(hit.compare_at_price);    
    
    // console.log(hit.meta.custom.discount_badge);
    let discountBadge = null;
    // if(typeof hit.meta != 'undefined' && typeof hit.meta.custom != 'undefined' && typeof hit.meta.custom.duscount_badge){
    //   discountBadge = hit.meta.custom.discount_badge;
    // }
    let tags = hit.tags;     
     // if(tags.includes("BF342")){
     //   discountBadge = "3 FOR 2";
     //   // console.log(discountBadge);
     // }
          
     if(discountBadgeMetaobject != 'null'){      
       const dBadgeObject = JSON.parse(discountBadgeMetaobject);      
       for(var i=0; i < dBadgeObject.length; i++){        
         if(tags.includes(dBadgeObject[i].tag)){
          discountBadge = dBadgeObject[i].message;           
           break;
        }   
       }
     }     

     // var reviewsStarsObj = getReviewsStars(hit); 
    var reviewsStarsObj = {}; //hide stars in collection page
    
    return html`
      <div   
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"     
      >
       <div class="product-card__figure">
        <badge-list class="badge-list badge-list--vertical">
         ${(hit.compare_at_price>0) &&
          html`
            <on-sale-badge discount-mode="percentage" class="badge badge--on-sale">Save ${((hit.compare_at_price-hit.price)/hit.compare_at_price *100).toFixed()}%</on-sale-badge>
          `
        }
         ${(discountBadge != null ) &&
            html `
              <on-sale-badge discount-mode="percentage" class="badge badge--on-sale discount_badge">${discountBadge}</on-sale-badge>
            `
            }
        </badge-list>
         <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" class="product-card__media" secImage="true" id="a-ID-${hit.objectID}">
             <img class="ais-hit--image product-card__image product-card__image--primary aspect-natural" src="${algoliaShopify.helpers.largeImage(hit)}" alt="${hit.title} - ${hit.variant_title}"
            srcset="${algoliaShopify.helpers.largeImage(hit)};width=200 200w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=300 300w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=400 400w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=500 500w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=600 2600w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=700 700w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=800 800w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=1000 1000w,
                    ${algoliaShopify.helpers.largeImage(hit)};width=1200 1200w,
            "
            width="1252" height="1252" loading="lazy" sizes="(max-width: 699px) calc(100vw / 2),(max-width: 999px) calc(100vw / 0 - 64px),calc((100vw - 96px) / 3 - (24px / 3 * 2))" 
            />             
            </a>
            <div class="quick-buy-container" QBhandle="${hit.handle}" id="QBB-ID-${hit.objectID}">
                <h5 class="quick-buy-container__heading">Add to Cart</h5>                                  
            </div>  
       </div>  
       <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
            <div style="font-size:small;">
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </div>
            </a>
          </p>
          <p
            class="ais-hit--subtitle" style="display: none"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <p class="ais-hit--price">
          ${(hit.compare_at_price>0)?
            html`
            <price-list class="price-list ">
              <sale-price class="h6 text-on-sale"><span class="sr-only">Sale price</span>
                ${salePrice}
              </sale-price>
              <compare-at-price class="h6 text-subdued line-through"><span class="sr-only">Regular price</span>
                ${regularPrice}
              </compare-at-price>
             </price-list>           
            `
            :
            html`
              <price-list class="price-list ">
                <sale-price class="h6 text-subdued"><span class="sr-only">Sale price</span>
                  ${salePrice}
                </sale-price>
              </price-list>
            `
          }          
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them --> 
          <!--  <div class="reviews_container product-card__info" data-product-id="${hit.id}" data-product-link="${algoliaShopify.helpers.instantsearchLink(hit)}" style="margin-bottom: 14px;"></div>-->            
            ${(typeof reviewsStarsObj.starsArr != 'undefined' && reviewsStarsObj.starsArr.length>0) && 
              html `
                <div class="reviews_container product-card__info" style="margin-bottom: 14px;">   
                  <a href="/products/${hit.handle}#shopify-product-reviews" class="rating-badge" title="${reviewsStarsObj.rating_count} reviews">
                    <div class="rating-badge__stars" role="img" aria-label="${reviewsStarsObj.rating_value} out of ${reviewsStarsObj.rating_max} stars">
                  ${
                    reviewsStarsObj.starsArr.map(el => html
                      `
                      ${(el.starti <= el.rating_value)?
                        html`
                          <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
                            <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#1c1c1c"/>
                          </svg>          
                        `
                      :(el.rating_decimal == 0.5)?
                        html `
                          <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-half" viewBox="0 0 12 11">
                            <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Z" fill="#1c1c1c"/>
                            <path d="M6 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#1c1c1c"/>
                            </svg>
                        `
                        :(el.rating_decimal == 1)?
                        html`
                          <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
                            <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#1c1c1c"/>
                          </svg>
                        `:
                        html`
                          <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-empty" viewBox="0 0 12 11">
                            <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#1c1c1c"/>
                          </svg>
                        `
                        }
                      `
                    )}    
                    </div> <span class="smallcaps text-xxs text-subdued">(${reviewsStarsObj.rating_value})</span></a>
                </div>
              `
              }
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}        
      </div></div>      
    `;
  }); 
});

/* Algolia search page */
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, handleItemClick) {      
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      
      // console.log('IS DAS');
      // console.log(templateOptions);
      
      var salePrice = getFinalPrice(item.price);
      var regularPrice = getFinalPrice(item.compare_at_price);

      // if(item.compare_at_price == 0)
      //   regularPrice = salePrice;

      // console.log(`salePrice is ${salePrice} regulaPrice is ${regularPrice}`);
    let discountBadge = null;
    // if(typeof item.meta != 'undefined' && typeof item.meta.custom != 'undefined' && typeof item.meta.custom.duscount_badge){
    //   discountBadge = item.meta.custom.discount_badge;
    // }  
    // console.log(item);
      let tags = item.tags;     
     // if(tags.includes("BF342")){
     //   discountBadge = "3 FOR 2";
     //   // console.log(discountBadge);
     // }
          
     if(discountBadgeMetaobject != 'null'){      
       const dBadgeObject = JSON.parse(discountBadgeMetaobject);      
       for(var i=0; i < dBadgeObject.length; i++){        
         if(tags.includes(dBadgeObject[i].tag)){
          discountBadge = dBadgeObject[i].message;           
           break;
        }   
       }
     }
      
      return html`
      <div>
        <div class="product-card__figure auto-complete">
           <badge-list class="badge-list badge-list--vertical">
             ${(item.compare_at_price>0) &&
              html`
                <on-sale-badge discount-mode="percentage" class="badge badge--on-sale">Save ${((item.compare_at_price-item.price)/item.compare_at_price *100).toFixed()}%</on-sale-badge>
              `
            }
            ${(discountBadge != null ) &&
            html `
              <on-sale-badge discount-mode="percentage" class="badge badge--on-sale discount_badge">${discountBadge}</on-sale-badge>
            `
            }
          </badge-list>
          <a href="${algoliaShopify.helpers.instantsearchLink(item)}" class="product-card__media" id="a-ID-${item.objectID}" secImage="true" aa-previousId="" aa-currentId="${item.objectID}">
            <img class="ais-hit--image product-card__image product-card__image--primary aspect-natural" src="${algoliaShopify.helpers.largeImage(item)}" alt="${item.title} - ${item.variant_title}"
              srcset="${algoliaShopify.helpers.largeImage(item)};width=200 200w,
                      ${algoliaShopify.helpers.largeImage(item)};width=300 300w,
                      ${algoliaShopify.helpers.largeImage(item)};width=400 400w,
                      ${algoliaShopify.helpers.largeImage(item)};width=500 500w,
                      ${algoliaShopify.helpers.largeImage(item)};width=600 2600w,
                      ${algoliaShopify.helpers.largeImage(item)};width=700 700w,
                      ${algoliaShopify.helpers.largeImage(item)};width=800 800w,
                      ${algoliaShopify.helpers.largeImage(item)};width=1000 1000w,
                      ${algoliaShopify.helpers.largeImage(item)};width=1200 1200w,
              "
              width="1252" height="1252" loading="lazy" sizes="(max-width: 699px) calc(100vw / 2),(max-width: 999px) calc(100vw / 0 - 64px),calc((100vw - 96px) / 3 - (24px / 3 * 2))" 
              />               
          </a>
              <!-- <div class="quick-buy-container" QBhandle="${item.handle}" id="QBB-ID-${item.objectID}" style="display:none;">
                   <h5 class="quick-buy-container__heading">Add to Cart</h5>
              </div>  -->
        </div> 
        <div class="aa-ItemContentBody">          
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${(item.compare_at_price>0)?
                html`
                <price-list class="price-list ">
                  <sale-price class="h6 text-on-sale"><span class="sr-only">Sale price</span>
                    ${salePrice}
                  </sale-price>
                  <compare-at-price class="h6 text-subdued line-through"><span class="sr-only">Regular price</span>
                    ${regularPrice}
                  </compare-at-price>
                </price-list>           
                `
                :
                html`
                  <price-list class="price-list ">
                    <sale-price class="h6 text-subdued"><span class="sr-only">Sale price</span>
                      ${salePrice}
                    </sale-price>
                  </price-list>
                `
              }                
            </div>
          </div>
        </div>
    </div>
  `;
    }
  );  
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html,state } = templateOptions;
     
    // consloe.log(isElement(elements.products));
    // var childeren = elements.products.querySelectorAll('.quick-buy-container');
    // console.log(childeren);
    // console.log(`status ${state.status}`);
    // if(state.status == 'idle')
       // aa_QuicjBuyButtonsRender();
   
    // const targetNode = document.getElementsByClassName('aa-Panel')[0];
    // // // Options for the observer (which mutations to observe)
    // const config = { attributes: true, childList: true, subtree: true };
    // // // Create an observer instance linked to the callback function
    // if(targetNode != null && targetNode.nodeType ==1){
    //   // console.log('observer is ',observer.isDisconnected());
    //   console.log('inside if');
    //    const observer = new MutationObserver(callback);  
    //     // // Start observing the target node for configured mutations
    //     observer.observe(targetNode, config);
    // }
   
    
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>
    `;
   
  });
});

// document.addEventListener('algolia.hooks.initialize', function() {
//   algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
//     // Change the placeholder text of the autocomplete menu
//     // console.log(options);
//     options.placeholder = "Search Our Products";
//     return options;
//   });
// });
// document.addEventListener('algolia.hooks.initialize', function() {
//   algoliaShopify.hooks.registerHook('beforeAutocompleteRedirectUrlOptions', function(options) {
//     // Change the default template for rendering redirect items 
//     // console.log('beforeAutocompleteRedirectUrlOptions..')
//     return {
//       templates: {
//         item({ html, state }) {
//           return html`<a className="myCustomClass">${state.query}</a>`;
//         },
//       },
//     };
//   });
// });



// document.addEventListener('algolia.hooks.initialize', function() {
//     algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {      
//       // console.log(item)  ;      
//       return html`      
//         <div style="display:grid; justify-content:left;">
//         <label class="${item.cssClasses.label}">
//           ${item.type === 'disjunctive' &&
//             (item.isRefined
//               ? html`
//                   <input
//                     type="checkbox"
//                     class="${item.cssClasses.checkbox}"
//                     checked
//                   />
//                 `
//               : html`
//                   <input type="checkbox" class="${item.cssClasses.checkbox}" />
//                 `)}
//           ${item.label}
//           </div>
//           <span class="${item.cssClasses.count}"> (
//             ${algoliaShopify.helpers.formatNumber(item.count)}
//             )
//           </span>
//         </label>
//       `;
//     });
//   });

// document.addEventListener('algolia.hooks.initialize', function() {
//   algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {        
//       // console.log(options);
//     return options;
//   });
// });

//rebuy-widgets Trustpilot 
document.addEventListener('rebuy:smartcart.show', (event) => {
  try {      
    const smartcart = event.detail.smartcart;
    if(!window.isRebuySmartCartReady){
      window.isRebuySmartCartReady = true;
      // console.log('rebuy:smartcart.show: smartcart', smartcart);      
      if(typeof trustPilotInfo != "undefined"){
         let rebuyWidgets = document.getElementsByClassName('rebuy-widget-content'); 
         for(let widget of rebuyWidgets) {
           let isElementSelected = false;
           if(widget.children.length >0){
             for(let child of widget.children){
               if(child.innerHTML =="People Also Bought"){
                 isElementSelected = true;
               }
             }
           }
           // console.log('isElemetSelected is ',isElementSelected);
           if(isElementSelected){
             let scoreString = trustPilotInfo.scoreString ?? 'Excellent';
             let scoreImage = trustPilotInfo.scoreImage ?? '"https://images-static.trustpilot.com/api/stars/4.5/128x24.png';
             let trustpilotLogo = trustPilotInfo.trustpilotLogo ?? '//images-static.trustpilot.com/api/logos/light-bg/72x18.png';
             
             const trustpilotSidget = document.createElement("div");
             trustpilotSidget.innerHTML = `
               <a id="profile-link" target="_blank" href="https://uk.trustpilot.com/review/vqfit.com?utm_medium=trustbox&amp;utm_source=MicroStar" aria-label="4.5 out of 5 star rating on Trustpilot" style="display: flex;  text-decoration: none;/*! margin: auto; *//*! align-self: ; *//*! align-content: last baseline; *//*! align-items: self-start; *//*! display: block; *//*! margin: 12px 0; */left: 10px;/*! position: inherit; *//*! text-align: center; */justify-content: center;align-items: center;" tabindex="-1">                        
                <div class="tp-widget-trustscore" aria-hidden="true" style="margin-right: 5px;font-weight: 600;">${scoreString}</div>
                <img src="${scoreImage}"> 
                <img src="${trustpilotLogo}">
               </a>
             `
             widget.insertAdjacentElement('afterbegin', trustpilotSidget)

           }
         }
      }
    }    
  }catch(err){
    console.log(`error in rebuy ${err.message}`)
  }
});

window.addEventListener("resize", () => {
  var windowSize = window.innerWidth; 
  var idStartsWith = "QBB-ID-";
  
   // console.log('window resized',windowSize);
   var qbbEl = document.querySelectorAll(`[id^=${idStartsWith}]`);
  // console.log(qbbEl);   
      qbbEl.forEach((el) => {
        if(windowSize < 1100){
          el.style.display = "none";
        }else {
           el.style.display = "block";
          for(const key in el.children){
            if(key > 0) {
              if(windowSize >=1100 && windowSize < 1440){
                el.children[key].style.width = "22px";
              }else if(windowSize >= 1440 && windowSize <1500) {
                el.children[key].style.width = "35px";
              }else {
                el.children[key].style.width = "55px";
              }
            }
          // console.log(key);
          // console.log(el.children[key]);
          }          
        }      
      });    

    
});

window.addEventListener("load", () => {
  try {
    
   // console.log('page loaded ...');
  // expandAllFacets();
  // const targetNode = document.getElementsByClassName('ais-Hits')[0];  
   const targetNode = document.getElementsByClassName('shopify-section--apps')[0]; 
  // const targetNode = document.getElementsByTagName('body')[0];
  const config = { attributes: true, childList: true, subtree: true };
  if(targetNode != null && targetNode.nodeType == 1){
    const observer = new MutationObserver(callback);    
    observer.observe(targetNode, config);
  }    
   QuicjBuyButtonsRender();

   // document.getElementById('autocomplete-0-input').addEventListener("keyup",function(){
   //   console.log('text pressed..')     
   //    const targetNode = document.getElementsByClassName('aa-Panel')[0];
   //   console.log(targetNode);
   //    const config = { attributes: true, childList: true, subtree: true };
   //    if(targetNode != null && targetNode.nodeType == 1){        
   //      console.log('aa-List mutation done');
   //      const observer = new MutationObserver(callback);    
   //      observer.observe(targetNode, config);
   //    }  
   //   QuicjBuyButtonsRender();
   //   },{once:false,capture:false})

  }catch(err){
    console.log(`error in load ${err.message}`)
  }      
});
var x = window.matchMedia("(min-width: 1024px)")
// x.addEventListener("change", function() {
//   windowChanged(x);
// });
// function windowChanged(x){
//   if(x.matches){
//     expandAllFacets();
//   }
// }
function expandAllFacets(){
  try {
    // console.log('inside expand facet..')
    if(x.matches){
      document
      .querySelectorAll(".ais-dropdown-checkbox")
      .forEach((i) => {        
        i.click(); 
        // console.log(i);
      }); 
    }  
  }catch(err){
    console.log(`error in expandAllFacets ${err.message}`)
  }
}

async function QuicjBuyButtonsRender(){
  try{
    document
    .querySelectorAll(".quick-buy-container")
    .forEach((i) => {
      //i.addEventListener("mouseover", function () {  
        // console.log('has attribute ', i.hasAttribute("QBhandle"));
        // console.log('child count',i.childElementCount);
        if(i.hasAttribute("QBhandle") && i.childElementCount == 1 ){
          let id = i.id;          
          let handle = i.getAttribute("QBhandle");
          var idAr = id.split("-");
          var objectId = idAr[2];
          
          const getVaraiantsData = async(id,handle) => {
            // console.log(`ost is ${window.location.host}`);
            const url = "https://" + window.location.host + '/products/' + handle + '.json';
            // console.log(`url is ${url}`);
            const response   = await fetch(url);
            // console.log(i.closest("li.ais-Hits-item"));
            // console.log(`hanlde ${handle} response is ${response.status}`);
            if(response.status == 200){
              const json       = await response.json();            
              const variants = json.product.variants;
              var productSecondImageSrc, productSecondImageAlt;
              if(json.product.images.length >1){
                productSecondImageSrc = json.product.images[1].src;
                productSecondImageAlt = json.product.images[1].alt;
              }else{
                productSecondImageSrc = json.product.images[0].src;
                productSecondImageAlt = json.product.images[0].alt;
              }
              
              const productId = json.product.id;
  
              addSecondaryImage(productSecondImageSrc,productSecondImageAlt,objectId);
              await getStockStatus(handle,id,variants);       
            }else {
              // var parentEl = i.closest("li.ais-Hits-item");
              // parentEl.style.display = 'none';
            }   
          }
          getVaraiantsData(id,handle);
        }     
      // });
    });
  }catch(err){
    console.log(`error in QuickjBuyButtonsRender ${err.message}`)
  }    
}

async function aa_QuicjBuyButtonsRender(){
  try {
    document
    .querySelectorAll(".product-card__media")
    .forEach((i) => {
      var aa_previousId = i.getAttribute("aa-previousId");
      var aa_currentId = i.getAttribute("aa-currentId");
      if(aa_previousId == aa_currentId){
        return;
      }else{
        i.setAttribute("aa-previousId",aa_currentId);
        document
        .querySelectorAll(".quick-buy-container")
        .forEach((i) => {
          //i.addEventListener("mouseover", function () {                
            if(i.hasAttribute("QBhandle") ){
              let id = i.id;          
              let handle = i.getAttribute("QBhandle");
              var idAr = id.split("-");
              var objectId = idAr[2];
              
              const getVaraiantsData = async(id,handle) => {
                const url = "https://" + window.location.host + '/products/' + handle + '.json';
                // console.log(`aa_quick url is ${url}`);
                // console.log(`aa_quick ${url}`);
                const response   = await fetch(url);
                const json       = await response.json();
              //   const options = json.product.options;
                const variants = json.product.variants;
                // const productImages = json.product.images               
                // const productId = json.product.id;
                // var option1 = [];
                // var option2 = [];
              //   options.forEach((op) => {
              //       if(op.name == "Size"){
              //           option1 = op.values;
              //       }
              //       if(op.name == "Colour"){
              //           option2 = op.values;
              //       }
              //   });
                
                // addSecondaryImage(productImages,objectId);
                await aa_getStockStatus(handle,id,variants);          
              }
              getVaraiantsData(id,handle);
            }     
          // });
        });      
      }
    });  
  }catch(err){
    console.log(`error in aa_quickjbuyButtonsRender ${err.message}`)
  }    
}

async function getStockStatus(handle,elmentId,variants){
  try {
    var isBackInStockNeeded = false;
      var htmlForm = '<h5 class="quick-buy-container__heading">Add to Cart</h5>';  
      variants.forEach((variant) =>{
        var option1 = variant.option1;
        option1 = sizeNameUnify(option1);   
        // console.log(variants);
        if(variant.inventory_policy == "continue" || variant.inventory_quantity >0){
            htmlForm = htmlForm +
            `<button onclick="_addMeToCart(event,this)" aria-controls="cart-drawer" aria-expanded="false" data-variant_id="${variant.id}">${option1} 
                <div class="add-success"> 
                <svg class="add-success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="45"/>
                </svg>
                <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"> <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>
                </div>
            </button>`
        }else{
            htmlForm = htmlForm + 
            `<button disabled data-variant_id="${variant.id}">${option1}<svg style='width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0;'><line x1="0" y1="100%" x2="100%" y2="0" style="stroke:#999999; stroke-width:1"/></svg>
            </button>`;
          isBackInStockNeeded = true;
        }
      });
    
      htmlForm = htmlForm + '</form>';
      qbDiv = document.getElementById(`${elmentId}`);
      
      if(qbDiv != null){
        //temporaray remove it to enable klaviyo BIS
        isBackInStockNeeded = false;  
        if(isBackInStockNeeded){
            htmlForm = htmlForm + 
            `<a class="button DAS_BIS_quickAdd klaviyo-bis-trigger" href="#" style="padding: inherit; text-align: center;color:white" data-klaviyo-handle="${handle}" onMouseOver="this.style.color='#000000'" onMouseOut="this.style.color='#ffffff'" >Notify Me When Available</a>`;
            
            qbDiv.innerHTML = htmlForm;
            
            qbDiv.classList.add("klaviyo-button-container");
            
            var parent = qbDiv.parentNode;
            var wrapper = document.createElement('div');
            wrapper.classList.add("klaviyo-product-container");
            wrapper.setAttribute("id",`klaviyo-data-handle-${handle}`);
            wrapper.setAttribute("data-klaviyo-handle",`${handle}`);       
      
            parent.replaceChild(wrapper, qbDiv);
            wrapper.appendChild(qbDiv);   
        }else {      
            qbDiv.innerHTML = htmlForm;
        }    
      }
  }catch(err){
    console.log(`error in getStockStatus ${err.message}`)
  }    
}

async function aa_getStockStatus(handle,elmentId,variants){
  try {
    var htmlForm = '<h5 class="quick-buy-container__heading"> Add to Cart</h5>';
    var isBackInStockNeeded = false;
    htmlForm = htmlForm + '<form class="nosto-form">';
    variants.forEach((variant) => {
        var option1 = variant.option1;
        option1 = sizeNameUnify(option1);
         if(variant.inventory_policy == "continue" || variant.inventory_quantity >0){
            htmlForm = htmlForm +
            `<button onclick="_addMeToCart(event,this)" aria-controls="cart-drawer" aria-expanded="false" data-variant_id="${variant.id}">${option1} 
                <div class="add-success"> 
                <svg class="add-success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="45"/>
                </svg>
                <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"> <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>
                </div>
            </button>`
        }else{
            htmlForm = htmlForm + 
            `<button disabled data-variant_id="${variant.id}">${option1}<svg style='width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0;'><line x1="0" y1="100%" x2="100%" y2="0" style="stroke:#999999; stroke-width:1"/></svg>
            </button>`;
            isBackInStockNeeded = true;
        }       
    });
    htmlForm = htmlForm + '</form>';
    qbDiv = document.getElementById(`${elmentId}`);

  //temporaray remove it to enable klaviyo BIS
    isBackInStockNeeded = false;
    if(isBackInStockNeeded){
        htmlForm = htmlForm + 
        `<a class="button DAS_BIS_quickAdd klaviyo-bis-trigger" href="#" style="padding: inherit; text-align: center;color:white" data-klaviyo-handle="${handle}" onMouseOver="this.style.color='#000000'" onMouseOut="this.style.color='#ffffff'" >Notify Me When Available</a>`;
        
        qbDiv.innerHTML = htmlForm;
        
        qbDiv.classList.add("klaviyo-button-container");
        
        var parent = qbDiv.parentNode;
        var wrapper = document.createElement('div');
        wrapper.classList.add("klaviyo-product-container");
        wrapper.setAttribute("id",`klaviyo-data-handle-${handle}`);
        wrapper.setAttribute("data-klaviyo-handle",`${handle}`);       

        parent.replaceChild(wrapper, qbDiv);
        wrapper.appendChild(qbDiv);   
    }else {
        if(qbDiv != null)
          qbDiv.innerHTML = htmlForm;
    }
  }catch(err){
    console.log(`error in aa_getStockStatus ${err.message}`)
  }    
}

function addSecondaryImage(imgSrc,imgAlt,eId){
  // console.log(`adding ${imgSrc}`);
  var imgHTML = '';
  imgHTML = imgHTML + `
        <img class="product-card__image product-card__image--secondary" 
        src="${imgSrc}"
        alt="${imgAlt}"
        srcset="${imgSrc};width=200 200w,
                ${imgSrc};width=300 300w,
                ${imgSrc};width=400 400w,
                ${imgSrc};width=500 500w,
                ${imgSrc};width=600 2600w,
                ${imgSrc};width=700 700w,
                ${imgSrc};width=800 800w,
                ${imgSrc};width=1000 1000w,
                ${imgSrc};width=1200 1200w,
        " 
        width="2500" 
        height="2500" 
        loading="lazy"               
        fetchpriority="low" sizes="(max-width: 699px) calc(100vw / 2), (max-width: 999px) calc(100vw / 0 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))"/>
  `
    var element = document.getElementById(`a-ID-${eId}`) ;
    if(element != null && element.getAttribute("secImage") == "true"){
        element.setAttribute("secImage","false");
        element.innerHTML += imgHTML;
      }
}

function aa_addSecondaryImage(images,eId){
  // console.log(`adding ${imgSrc}`);
  var imgHTML = '';
  imgHTML = imgHTML + `
    <img class="ais-hit--image product-card__image product-card__image--primary aspect-natural" src="${images[0].src}" alt="${images[0].alt}"
      srcset="${images[0].src};width=200 200w,
              ${images[0].src};width=300 300w,
              ${images[0].src};width=400 400w,
              ${images[0].src};width=500 500w,
              ${images[0].src};width=600 2600w,
              ${images[0].src};width=700 700w,
              ${images[0].src};width=800 800w,
              ${images[0].src};width=1000 1000w,
              ${images[0].src};width=1200 1200w,
      "
      width="1252" height="1252" loading="lazy" sizes="(max-width: 699px) calc(100vw / 2),(max-width: 999px) calc(100vw / 0 - 64px),calc((100vw - 96px) / 3 - (24px / 3 * 2))" 
      />   
    `;
  imgHTML = imgHTML + `
        <img class="product-card__image product-card__image--secondary" 
        src="${images[1].src}"
        alt="${images[1].alt}"
        srcset="${images[1].src};width=200 200w,
                ${images[1].src};width=300 300w,
                ${images[1].src};width=400 400w,
                ${images[1].src};width=500 500w,
                ${images[1].src};width=600 2600w,
                ${images[1].src};width=700 700w,
                ${images[1].src};width=800 800w,
                ${images[1].src};width=1000 1000w,
                ${images[1].src};width=1200 1200w,
        " 
        width="2500" 
        height="2500" 
        loading="lazy"               
        fetchpriority="low" sizes="(max-width: 699px) calc(100vw / 2), (max-width: 999px) calc(100vw / 0 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))"/>
    `;
    var element = document.getElementById(`a-ID-${eId}`) ;           
        element.innerHTML = imgHTML;
     
}


function checkElementExist(id){
  var e = document.getElementById(id);
  if(e !=null){
    console.log(`element id ${id} is exist`);
    e.setAttribute("secImage","true");
    // e.innerHTML = '';
  }
    
  else
  console.log(`element id ${id} is NOT exist`);
}

function sizeNameUnify(size){
    var unifyName = "";
    switch(size){
        case "Small":
        case "S UK 2-5":
        case "S - M":
            unifyName = "S";
            break;
        case "Large":
        case "L UK 8-11":
            unifyName = "L";
            break;
        case "Medium":
        case "M UK 5-8":
            unifyName = "M";
            break;        
        case "Extra Small":
            unifyName = "XS";
            break;
        case "Extra Large":
            unifyName = "XL";
            break;
        default:
            unifyName = size;
    }
    return unifyName
}
function getFinalPrice(price){
  var finalPrice;
  var currency = Shopify.currency;
  var local = Shopify.locale;
  var country = Shopify.country

   // console.log(`price is ${price}`);
   // console.log(currency,local,country);

  if(currency.active == "GBP")
		return Intl.NumberFormat(local, {currency: currency.active, style: 'currency'}).format(price);
  if(price == 0)
		return Intl.NumberFormat(local, {currency: currency.active, style: 'currency'}).format(0);  
	switch(currency.active){
		case "EUR":
				var increaseFactor = getAlgoliaMarketPrices() != -1?getAlgoliaMarketPrices():5;
				// if(country == 'AD' || country == 'CY' || country == 'EE' || country == 'FI' || country == 'GR' || country == 'XK' || country == 'LV' || country == 'LT' || country == 'LU' || country == 'MT' || country == 'MC' || country == 'ME' || country == 'PT' || country == 'SM' || country == 'SK' || country == 'SI')
    //               increaseFactor = 2;
                var roundingFactor = 95
				var sPrice = (price * (1+increaseFactor/100) * parseFloat(currency.rate)).toFixed(2);
				var arPrice = sPrice.split(".");
				var a = parseInt(arPrice[0]);
				var b = parseInt(arPrice[1]);
				if(b <=roundingFactor ) {
					finalPrice = "" + a + "." + roundingFactor;
				}else {
					finalPrice = "" + (a+1) + "." + roundingFactor;
				}
			break;
		case "JPY":
				var increaseFactor = getAlgoliaMarketPrices() != -1?getAlgoliaMarketPrices():2;
				var roundingFactor = 100
				var sPrice = (price * (1+increaseFactor/100) * parseFloat(currency.rate)).toFixed(0);
                
                var temp = Math.ceil(sPrice/roundingFactor)*roundingFactor;
				
    //             var b = parseInt(sPrice.slice(-3));
				// var a = parseInt(sPrice.substring(0,sPrice.length-3));
				
				// if(b <=roundingFactor ) {
				// 	finalPrice = "" + a + roundingFactor;
				// }else {
				// 	finalPrice = "" + (a+1) + roundingFactor;
				// }
                  // console.log(` JAPAN sPrice is ${sPrice} a is ${a} b is ${b} finalPrice is ${finalPrice} temp is ${temp}`);
                finalPrice = temp;
			break;
		case "UAE":
				var increaseFactor = getAlgoliaMarketPrices() != -1?getAlgoliaMarketPrices():10;
				finalPrice = (Math.ceil(price * (1+increaseFactor/100) * parseFloat(currency.rate))).toFixed(2);
			break;
      case "USD":
			var increaseFactor = getAlgoliaMarketPrices() != -1?getAlgoliaMarketPrices():16;
				finalPrice = (price * (1+increaseFactor/100) * parseFloat(currency.rate)).toFixed(2);				
				if(finalPrice.length <= 6){
					finalPrice = (Math.ceil(price * (1+increaseFactor/100) * parseFloat(currency.rate))).toFixed(2);
				}else if(finalPrice.length >6 && finalPrice <=7) {
					finalPrice = parseFloat(finalPrice)/100
					finalPrice = Math.ceil(finalPrice)*100;
					finalPrice = finalPrice.toFixed(2);
				}else {
					finalPrice = parseFloat(finalPrice)/100
					finalPrice = Math.ceil(finalPrice)*100;
					finalPrice = finalPrice.toFixed(2);
				}          
            break;
      default:
			var increaseFactor = getAlgoliaMarketPrices() != -1?getAlgoliaMarketPrices():0;
				finalPrice = (price * (1+increaseFactor/100) * parseFloat(currency.rate)).toFixed(2);				
				if(finalPrice.length <= 6){
					finalPrice = (Math.ceil(price * (1+increaseFactor/100) * parseFloat(currency.rate))).toFixed(2);
				}else if(finalPrice.length >6 && finalPrice <=7) {
					finalPrice = parseFloat(finalPrice)/100
					finalPrice = Math.ceil(finalPrice)*100;
					finalPrice = finalPrice.toFixed(2);
				}else {
					finalPrice = parseFloat(finalPrice)/100
					finalPrice = Math.ceil(finalPrice)*100;
					finalPrice = finalPrice.toFixed(2);
				}
	}
	
    return Intl.NumberFormat(local, {currency: currency.active, style: 'currency'}).format(finalPrice);
}

function addCollectionBanner(){
  // console.log(collection_banner);
  if(typeof collection_banner != "undefined" && collection_banner != null){    
    var ctaButton="",heading="";
    let startRow = collection_banner.startRow;
    let startCol = collection_banner.startCol;
    
    if(collection_banner.cta_text != "hide"){
      ctaButton = `
        <div style="padding:10px; text-align:center;"> 
          <a href="${collection_banner.cta}">
            <button class="button">${collection_banner.cta_text}</button>
          </a>
        </div>
      `
    }
    if(collection_banner.title != "hide"){
      heading = `
       <div style="padding:10px; text-align:center;color:black;">
        <span>${collection_banner.title}</span>
      </div>
      `     
    }
     var res =  `
    <div class="ais-hit">
      <div>
        <div class="product-card__figure">
          <div class="justify-self-center">
            <div>
              <a href="${collection_banner.cta}">
                <img src="${collection_banner.image}"/>              
              </a>
            </div>
            ${heading}
            ${ctaButton}
          </div>
        </div>
      </div>
    </div>        
  `
    var hitItem = document.createElement('li');
    // hitItem.className = "ais-Hits-item ais-Hits-item-hide-on-mobile";
     hitItem.className = "ais-Hits-item";
   
    var matchMobile = window.matchMedia("screen and (max-width:699px)");
    var matchTablet = window.matchMedia("screen and (min-width:700px) and (max-width:1023px");

     // console.log(matchMobile.media);     //"screen and (max-width:800px)"
     // console.log(matchMobile.matches);   //true or false
    if(matchMobile.matches){
       startCol = 2;
    }else if(matchTablet.matches){
      startCol = 3;
    }
    // match.addListener(function(match){
    //   console.log(match.media);
    //   if (match.media == "screen and (max-width:700px) and (min-width:1023)") {
    //         startCol = 3
    //         hitItem.style.gridArea = ` ${startRow} / ${startCol} / span 1 / span 1`;
    //   }else if(match.media == "screen and (max-width:699px)"){
    //     startCol = 2
    //     hitItem.style.gridArea = ` ${startRow} / ${startCol} / span 1 / span 1`;
    //   }
    // });
    // hitItem.className = "ais-Hits-item";
    // hitItem.style.gridColumnStart = 1;//3;
    // hitItem.style.gridColumnEnd = 1;//5;
    // hitItem.style.gridRowStart= 1;
    // hitItem.style.gridRowEnd = 1;//3;
   
   
    hitItem.style.gridArea = ` ${startRow} / ${startCol} / span 1 / span 1`;
    hitItem.innerHTML = res;
    
    const targetNode = document.querySelectorAll('.ais-Hits-list')[0];  
    targetNode.appendChild(hitItem);
  }  
}

function getAlgoliaMarketPrices(){
  let priceIncrease = -1;
  try {
    const countryName = new Intl.DisplayNames(['en'], { type: 'region' });
    let country = Shopify.country;
   
     var marketPrices = null;
     if(algoliaMarketPrices != 'null'){         
       const marketPrices = JSON.parse(algoliaMarketPrices);      
       for(var i=0; i < marketPrices.length; i++){        
         if(countryName.of(country) == marketPrices[i].country){
           priceIncrease = marketPrices[i].price_increase;
           break;
         }                      
       }
     }
  }catch(error){
    console.log(`error is ${error.message}`);
  }    
  console.log(`market price increase is ${priceIncrease}`);
  return priceIncrease;
}

// document.addEventListener('rebuy.productsChange', (e) => {
//   const widget = e.detail.widget;
//    console.log(widget);
//   if(widget.id == "164314"){
//     let p=0;
//       widget.data.products.forEach((product) => {
//          console.log(p++);
//         let discountBadge = null;
//          if(discountBadgeMetaobject != 'null'){      
//          const dBadgeObject = JSON.parse(discountBadgeMetaobject);      
//          for(var i=0; i < dBadgeObject.length; i++){        
//            if(product.tags.includes(dBadgeObject[i].tag)){
//               discountBadge = dBadgeObject[i].message;           
//                break;
//             }   
//          }           
//        }
//         console.log(`message is ${discountBadge}`);
//       });
//   }
  
  
// });

document.addEventListener('rebuy.ready', function(event){
    // console.log('rebuy.ready event', event.detail);
   let badges;
  if(event.detail.widget.id = "164314" && discountBadgeMetaobject != 'null' ){ // && !window.rebuySaleBadgeAdded){
    badges = document.querySelectorAll('.rebuy-sale-badge');
    badges.forEach((e,index) => {
      let tags = e.getAttribute('data').split(",");
      let discountBadge = null;     
      const dBadgeObject = JSON.parse(discountBadgeMetaobject);
      for(var i=0; i < dBadgeObject.length; i++){        
       if(tags.includes(dBadgeObject[i].tag)){
          discountBadge = dBadgeObject[i].message;           
           break;
        }   
     }        
      if(discountBadge != null){
        e.innerHTML = ` <span class="badge badge--on-sale discount_badge">${discountBadge}</span>`;
      }
      // console.log(`index is ${index} message is ${discountBadge}`);
    })
    // window.rebuySaleBadgeAdded = true;
  }
  
});

// async function getReviews(){
//   // let result = '';  
//   let renderedProductsSet = new Set(window.renderedProducts);
//   let uniqueRenderedProducts = [...renderedProductsSet];
//   // console.log('hit length',window.renderedProducts.length,'uique hit is',uniqueRenderedProducts);
  
//   let products_reviews = [];
//   try {
//     if(uniqueRenderedProducts.length>0){
//       const myHeaders = new Headers();
//       myHeaders.append("X-Shopify-Storefront-Access-Token", "");
//       myHeaders.append("Content-Type", "application/json");
//       const endpointURL = "https://bigbossgymwear.myshopify.com/api/2024-07/graphql.json";
      
//       let productsQuery = [];
//       uniqueRenderedProducts.forEach((e)=>{
//           productsQuery.push(`gid://shopify/Product/${e}`);   
//       })
//        // console.log(JSON.stringify(productsQuery));
//       var query = `query Products($ids: [ID!]!) {
//         nodes(ids: $ids) {
//           ... on Product {
//             id
//             handle
//             rating:metafield(namespace: "reviews", key: "rating") {
//                   value
//               }
//             rating_count: metafield(namespace: "reviews", key: "rating_count") {
//                  value
//              }
//           }
//         }
//       }`;    
      
//       const graphql = JSON.stringify({
//         query: query,
//         variables: {"ids": productsQuery}
//       })
//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: graphql,
//         redirect: "follow"
//       };
//       const response = await fetch(endpointURL, requestOptions);
//       const result = await response.json();
//       let nodes = result.data.nodes;
//       nodes.forEach((product) =>{
//         // console.log(product);
//         if(product != null){
//           let review= {
//               id: product.id.split("/")[4],
//               handle : product.handle,
//               rating : product.rating != null ? JSON.parse(product.rating.value):'',
//               rating_count:product.rating_count != null ?product.rating_count:0
//           }    
//           products_reviews.push(review);
//         }        
//           });
//       // console.log(JSON.stringify(products_reviews));
//     }
//     document
//       .querySelectorAll(".reviews_container")
//       .forEach((product) => {
//       	const pid = product.getAttribute("data-product-id");
//         const pUrl = product.getAttribute("data-product-link");
        
//         if(pid != null && products_reviews.length>0){ 
//           let json = products_reviews.filter(item => item.id == pid);
//            // console.log(`id is ${pid} json is ${JSON.stringify(json)}`);
//               if(json.length>0 && json[0].rating != ""){
//                 const rating = json[0].rating;
//                 const rating_count = parseInt(json[0].rating_count.value);                
//                 const rating_value = parseFloat(rating.value);
//                 const rating_max = parseFloat(rating.scale_max);
//                 var rating_decimal = 0;
//                 var decimal = parseFloat((rating_value % 1).toFixed(2)); 
//                 var productUrl = `/products/${json[0].handle}#shopify-product-reviews`
                
//                 if(decimal >= 0.3 && decimal <= 0.7)
//                   rating_decimal = 0.5;
//                 else if(decimal > 0.7)
//                   rating_decimal = 1;

//                 // console.log('rating_value',rating_value,'rating_max',rating_max,'rating_count',rating_count,'decimal',decimal);
                
//                 result = `<a href="${pUrl}#shopify-product-reviews" class="rating-badge" title="${rating_count} reviews">
//                           <div class="rating-badge__stars" role="img" aria-label="${rating_value} out of ${rating_max} stars">
//                         `;
                
//                 for(let i=1;i<=rating_max;i++){
//                   if(i<=rating_value){
//                     result = `${result} <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
//                                  <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#1c1c1c"/>
//                                 </svg>          
//                               `;
//                   }else {
//                     if(rating_decimal == 0.5)
//                       result = `${result} 
//                           <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-half" viewBox="0 0 12 11">
//                           <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Z" fill="#1c1c1c"/>
//                           <path d="M6 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#1c1c1c"/>
//                         </svg>
//                       `;
//                     else if(rating_decimal == 1)
//                       result = `${result} <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
//                                  <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#1c1c1c"/>
//                                 </svg>          
//                               `;   
//                     else
//                       result = `${result}
//                             <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-empty" viewBox="0 0 12 11">
//                               <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#1c1c1c"/>
//                             </svg>
//                       `;
          
//                     rating_decimal = false;
//                   }
//                 }
//                 result = `${result} </div> <span class="smallcaps text-xxs text-subdued">(${rating_value})</span></a>
//                 `;
//                   product.innerHTML = result   
//               }                                          
//         }
       
       
//       });
//     window.renderedProducts = [];
//     // window.isReviewsRendered = false;
//   }catch(error){
//     console.log(`error is ${error.message}`);
//   } 
//   // return html `${result}`;
// }
function getReviewsStars(hit){
    let reviewsObj={};    
    try {        
        if(hit.hasOwnProperty("meta") && hit.meta.hasOwnProperty("reviews") && hit.meta.reviews.hasOwnProperty("rating") 
            && hit.meta.reviews.rating != null && hit.meta.reviews.hasOwnProperty("rating_count") && hit.meta.reviews.rating_count != null){
              const rating = JSON.parse(hit.meta.reviews.rating);
              const rating_value = rating.value != null ? rating.value:0;
              const rating_max = rating.scale_max != null ?rating.scale_max :0;
              const rating_count = hit.meta.reviews.rating_count != null ? hit.meta.reviews.rating_count :0;
              if(rating_value >0 && rating_max >0 && rating_count >0){
                var rating_decimal = 0;
                var decimal = parseFloat((rating_value % 1).toFixed(2)); 
                var productUrl = `/products/${hit.handle}#shopify-product-reviews`
                
                
                var reviewStarsArr = [];
                if(decimal >= 0.3 && decimal <= 0.7)
                  rating_decimal = 0.5;
                else if(decimal > 0.7)
                  rating_decimal = 1;
                              
                for(let i=1;i<=rating_max;i++){
                    reviewStarsArr.push(
                        {
                            starti:i,
                            rating_value:Number(rating_value),
                            rating_decimal:Number(rating_decimal)
                        }
                    );
                }   
                reviewsObj = {
                    rating_value: Number(rating_value),
                    rating_max: Number(rating_max),
                    rating_count:Number(rating_count),
                    starsArr:reviewStarsArr
                };
              }
        }
    }catch(error){
        console.log(`getReviewsStars error is ${error.message}`)
        resultHTML = ""
    }
    return reviewsObj;
}
document.addEventListener("facet:update", async (event) => {
  // console.log('filter applied...');
  // const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  // url.searchParams.forEach(element => {
  //   console.log(element);
  // });  
});
